import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";

import Admin from "./pages/Admin";
import Main from "../src/user_components/Main";
import { LanguageProvider } from "./i18n/LanguageContext";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <LanguageProvider>
                <Main />
              </LanguageProvider>
            }
          /> {/* 로그인 페이지 */}

          <Route path="/admin" element={<Admin />} />
        </Routes>
      </Router>
      {/* <Main /> */}
    </>


  );
}

export default App;
